import createIcon from '../../createIcon';

/**
 * @component @name ListAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNVYxOUg1VjVIMTlaTTIwLjEgM0gzLjlDMy40IDMgMyAzLjQgMyAzLjlWMjAuMUMzIDIwLjUgMy40IDIxIDMuOSAyMUgyMC4xQzIwLjUgMjEgMjEgMjAuNSAyMSAyMC4xVjMuOUMyMSAzLjQgMjAuNSAzIDIwLjEgM1pNMTEgN0gxN1Y5SDExVjdaTTExIDExSDE3VjEzSDExVjExWk0xMSAxNUgxN1YxN0gxMVYxNVpNNyA3SDlWOUg3VjdaTTcgMTFIOVYxM0g3VjExWk03IDE1SDlWMTdIN1YxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ListAlt = createIcon('ListAlt', [
  [
    'path',
    {
      d: 'M19 5V19H5V5H19ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15Z',
      key: '1piljz',
    },
  ],
]);

export default ListAlt;
